import React, { useEffect, useState } from "react";
import {
  Layout,
  Card,
  Form,
  Input,
  Upload,
  Button,
  message,
  Image,
  Select,
  Typography,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { BASE_URL } from "../Config";
import axios from "axios";
import Sidebar from "../Components/Sidebar";
import SuccessPopup from "../Components/popup/SuccessPopup";
import ErrorPopup from "../Components/popup/ErrorPopup";
import countries from "world-countries";
import { MenuOutlined } from "@ant-design/icons";

const { Header, Content } = Layout;
const { Option } = Select;
const { Text: AntText } = Typography;

const EditVariation = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);

  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [newImage, setNewImage] = useState(null);

  const [allAsanas, setAllAsanas] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role || "user";

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    const fetchAsanas = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const res = await axios.get(`${BASE_URL}/asanadetails`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAllAsanas(res.data.asanas || []);
      } catch (err) {
        console.log(err);
      }
    };
    fetchAsanas();
    fetchVariation();
  }, []);

  const fetchVariation = async () => {
    const token = sessionStorage.getItem("token");

    try {
      const res = await axios.get(`${BASE_URL}/uservariations/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const v = res.data.variation || res.data;

      form.setFieldsValue({
        name: v.name,
        sanskrit: v.sanskrit,
        country: v.country,
        english: v.english,
        poseType: Array.isArray(v.poseType) ? v.poseType.join(", ") : "",
        parentAsana: v.parentAsana?._id, // ✅ IMPORTANT
        mediaLink: v.mediaLink,
      });

      setImagePreview(v.image);
      setLoading(false);
    } catch (err) {
      console.error(err);
      message.error("Could not fetch variation");
    }
  };

  const handleUpdate = async (values) => {
    setBtnLoading(true);

    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("sanskrit", values.sanskrit);
    formData.append("country", values.country);
    formData.append("english", values.english);
    formData.append("mediaLink", values.mediaLink);
    formData.append("parentAsana", values.parentAsana);

    values.poseType
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
      .forEach((item) => formData.append("poseType[]", item));

    if (newImage) formData.append("image", newImage);

    try {
      const res = await axios.put(
        `${BASE_URL}/uservariations/${id}`,
        formData,
        {
         headers: {
  Authorization: `Bearer ${sessionStorage.getItem("token")}`, 
  "Content-Type": "multipart/form-data",
},
        },
      );

      if (res.data.success) {
        setSuccessPopup(true);

        // Navigate AFTER popup closes
        setTimeout(() => navigate("/my-variation"), 1500);
      } else {
        setErrorPopup(true);
        message.error(res.data.message || "Update failed");
      }
    } catch (err) {
      console.error(err);
      setErrorPopup(true);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}

        collapsedWidth="0"
        role={role}
      />

      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 40 : 210,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >

        <Header className="MainHeader">

          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}

          <div style={{ flex: 1 }}>
            <AntText
              style={{
                fontSize: 20,
                fontWeight: "bold"
              }}
            >
              All Make Variation
            </AntText>
          </div>

        </Header>
        <Content style={{ padding: 20 }}>
          <Card
            title="Edit Variation"
            bordered={false}
            style={{ maxWidth: 800, margin: "0 auto" }}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={handleUpdate}
              autoComplete="off"
            >
              <Form.Item
                label="name"
                name="name"
                rules={[{ required: true, message: "name is required" }]}
              >
                <Input placeholder="Padmasana in Aranyasana" />
              </Form.Item>

              <Form.Item label="Parent Asana" name="parentAsana">
                <Select
                  showSearch
                  placeholder="Search parent asana..."
                  allowClear
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={allAsanas.map((a) => ({
                    value: a._id,
                    label: a.name,
                  }))}
                />
              </Form.Item>

              <Form.Item
                label="Sanskrit"
                name="sanskrit"
                rules={[{ required: true, message: "Sanskrit is required" }]}
              >
                <Input placeholder="Sanskrit name" />
              </Form.Item>

              <Form.Item
                label="Country"
                name="country"
                rules={[{ required: true, message: "Please select country" }]}
              >
                <Select
                  showSearch
                  placeholder="Select country"
                  options={countries.map((c) => ({
                    label: c.name.common,
                    value: c.name.common,
                  }))}
                />
              </Form.Item>

              <Form.Item
                label="English"
                name="english"
                rules={[{ required: true, message: "English is required" }]}
              >
                <Input placeholder="English description" />
              </Form.Item>

              <Form.Item
                label="Pose Type (comma separated)"
                name="poseType"
                rules={[{ required: true, message: "Pose types are required" }]}
              >
                <Input placeholder="prone, backbend" />
              </Form.Item>

              <Form.Item
                label="Media link"
                name="mediaLink"
                rules={[{ required: true, message: "Enter media link" }]}
              >
                <Input placeholder="https://www.youtube.com/" />
              </Form.Item>

              <Form.Item label="Current Image">
                <Image
                  src={imagePreview}
                  width={150}
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item label="Replace Image">
                <Upload
                  beforeUpload={(file) => {
                    setNewImage(file);

                    const reader = new FileReader();
                    reader.onload = (e) => setImagePreview(e.target.result);
                    reader.readAsDataURL(file);

                    return false;
                  }}
                  maxCount={1}
                >
                  <Button icon={<UploadOutlined />}>Upload New Image</Button>
                </Upload>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  loading={btnLoading}
                >
                  Update Variation
                </Button>
              </Form.Item>
            </Form>
            <SuccessPopup
              open={successPopup}
              message="Variation updated successfully!"
              onClose={() => setSuccessPopup(false)}
            />
            <ErrorPopup
              open={errorPopup}
              setOpen={setErrorPopup}
              message="Variation update failed"
            />
          </Card>
        </Content>
      </Layout>
    </Layout>
  );
};

export default EditVariation;
